
import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
  BrowserRouter,
  Switch
} from 'react-router-dom'

import i18n from "./i18n";

import {  withNamespaces } from "react-i18next";

// import AdminConfig from 'app/view/containers/AdminConfig/AdminConfig';
//import AdminConfig from './app/view/containers/AdminConfig/AdminConfig';
// import logo from './logo.svg';
import history from './history';
import Login from './app/view/containers/Login/Login';
import MainSummary from './app/view/containers/MainSummary/MainSummary';
import Monitor from './app/view/containers/Monitor/Monitor';
import AdminConfig from './app/view/containers/AdminConfig/AdminConfig';
import CommingSoon from './app/view/containers/CommingSoon';
import Maintenance from './app/view/containers/Maintenance/Maintenance';
import Report from './app/view/containers/Report/Report';
import Payment from './app/view/containers/Payment/Payment';
var nocache = require('nocache')
nocache()

class App extends Component {

  // render() {
  //   return (
  //     <div className="App">
  //       <AdminConfig />
  //       <Monitor />
  //     </div>
  //   );
  // }
  renderRouter(){
    return(

        <Router history={history}>
          <Switch>
            <Route exact path="/" component={Login}/>
            <Route path="/main" component={MainSummary}/>
            <Route path="/monitor" component={Monitor}/>
            <Route path="/admin_config" component={AdminConfig}/>
            <Route path="/maintenance" component={Maintenance}/>
            <Route path="/report" component={Report}/>
            <Route path="/payment" component={Payment}/>
            <Route path="/commingsoon" component={CommingSoon}/>
            <Route component={<div>TOTO !!!!</div>}/>
          </Switch>
        </Router>

    )
  }
  render() {
    const { t } = this.props;
    return (


      <div>
      <BrowserRouter>{this.renderRouter()}</BrowserRouter>
      </div>
    );
  }
}
export default withNamespaces('Login')(App);




// WEBPACK FOOTER //
// ./src/App.js